import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, ReportService, SessionInformationService } from 'app/core/core.module';
import { BuildAssembly } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';

@Component({
    selector: 'app-build-assembly-overview',
    templateUrl: './build-assembly-overview.component.html',
    styleUrls: ['./build-assembly-overview.component.scss'],
    standalone: false,
})
export class BuildAssemblyOverviewComponent implements OnInit {
    statuses: any[];
    buildAssemblies: any;

    showAllOrders = false;
    filter: any;
    showCompleted = false;
    canUpdateStatus = false;
    canCancelOrder = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        private auth: AuthService,
        private reportService: ReportService,
        private appInfo: AppInformationService,
        private sessionInfo: SessionInformationService
    ) {}

    async ngOnInit() {
        this.showCompleted = !!this.sessionInfo.getItem('build-assembly-show-completed');
        this.statuses = this.uow.lookups.buildAsseblyStatuses;
        await this.getData();
    }

    async getData() {
        this.buildAssemblies = await this.uow.getBuildAssemblies(this.showCompleted);
    }

    async toggleCompleted() {
        this.showCompleted = !this.showCompleted;
        this.sessionInfo.setItem('build-assembly-show-completed', this.showCompleted, false);
        await this.getData();
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(build: any) {
        this.router.navigate(['/build-assemblies/' + (!!build?.id ? build.id : 'new')]);
    }

    openPurchaseOrder(buildAssembly: BuildAssembly) {
        if (!buildAssembly) return;
        this.router.navigate(['/purchase-orders/' + buildAssembly.purchaseOrderId]);
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data);
    }

    async delete() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;
        const success = await confirm('Are you sure you want to DELETE this build assembly?', this.appInfo.settings.company);
        if (!success) return;

        selectedRow.deleted = new Date();
        selectedRow.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
    }

    async printReport() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        await this.reportService.printBuildAssemblyReport(selectedRows[0].id);
    }
}
